import StarryNightForest from "assets/starry-night-forest.jpg";
import Empty from "./EmptyPageContent";

export default function NotFound() {
  const returnText = "Hmm... This path leads nowhere";
  return <Empty heading={returnText} image={{ src: StarryNightForest, alt: "Path to nowhere..." }} />;
}
